<template>
  <div class="wrapper">
    <div class="main visual-2 /enter-phone visual-5">
      <div class="container">
        <Header :backRoute="'/'" />
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="vis4-inr1">
              <h1>Enter Your Code</h1>
              <form
                class="namesearch code-form"
                id="codeForm"
                action="good-to-go"
                method="get"
              >
                <label for="name"></label><br />
                <input
                  type="text"
                  id="digit1"
                  name="digit1"
                  maxlength="1"
                  required
                  class="code-input"
                />
                <input
                  type="text"
                  id="digit2"
                  name="digit2"
                  maxlength="1"
                  required
                  class="code-input"
                />
                <input
                  type="text"
                  id="digit3"
                  name="digit3"
                  maxlength="1"
                  required
                  class="code-input"
                />
                <input
                  type="text"
                  id="digit4"
                  name="digit4"
                  maxlength="1"
                  required
                  class="code-input"
                />
                <input
                  type="text"
                  id="digit5"
                  name="digit5"
                  maxlength="1"
                  required
                  class="code-input"
                />
                <input
                  type="text"
                  id="digit6"
                  name="digit6"
                  maxlength="1"
                  required
                  class="code-input"
                />
                <br />
                <button type="submit" class="btn btn-primary">Submit</button>
              </form>
            </div>
          </div>
        </div>
        <FooterView :showButtons="true" />
      </div>
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "EnterPhone",
  mounted() {
    // Attach the moveToNext function only for forms with the class 'code-form'
    document
      .querySelectorAll(".code-form .code-input")
      .forEach((input, index, inputs) => {
        input.addEventListener("input", function () {
          if (this.value.length === 1) {
            const nextInput = inputs[index + 1];
            if (nextInput) {
              nextInput.focus(); // Move to the next input if it exists
            }
          }
        });
      });
  },
};
</script>
